// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__nQi1b","actions":"GroupTable_actions__1jhmI","deleteModalFooter":"GroupTable_deleteModalFooter__rGDAp"};